module.exports = __webpack_public_path__ + "0c92bf3d3ba572e695f796b0e9eb92c5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/clojure.png
// module id = 373
// module chunks = 1